import { api } from './axios_settings'
export default {
  install (Vue, options) {
    Vue.prototype.$api = {
      execute (method, url, model) {
        return api[method](url, model)
      },
      getSingleRecordHandler (url) {
        return this.execute('get', url)
      },
      saveUpdateHandler (urlVal, model) {
        return new Promise((resolve, reject) => {
          let method = model.id ? 'put' : 'post'
          let url = model.id ? `${urlVal}/${model.id}` : urlVal
          let text = model.id ? 'message.common.updatedSuccess' : 'message.common.addedSucess'
          this.execute(method, url, model)
            .then(response => {
              response.data = { ...response.data, ...{ snackbar: { snackbar: true, color: 'success', text: text } } }
              resolve(response.data)
            })
            .catch((error) => {
              reject(error)
            })
        })
      }
    }
  }
}
